module.exports = __webpack_public_path__ + "img/egwi.b8545548.svg";